import { useLocation } from 'react-router-dom';

/**
 * The same signal, read off a search string rather than through the router.
 *
 * For callers with no hook to call — the redux effects and selector that reach into the
 * `getNatalieEvent` cache, whose key carries `isTestLink`. They used to pass `false` outright,
 * which missed the entry a rehearsal visit had populated under `true`: the lookup came back
 * empty, the assert behind it threw, the catch logged, and Join did nothing at all.
 *
 * One rule in one place, so the cache cannot be written under one key and read under another.
 */
export const isTestLinkSearch = (search: string): boolean => new URLSearchParams(search).get('testInviteCode') !== null;

/**
 * Resolve the test invite code from the URL query (`?testInviteCode=…`) — the
 * single, unified Natalie test signal across both the Guest (accountless) and
 * Registered flows. The room/feedback forward this code to the token mint, where
 * the SERVER matches it against the event's stored `testInviteCode` to resolve
 * `source=test`. The client never asserts test-ness — it only relays the
 * (already-public) code the participant arrived with.
 */
export const useTestInviteCode = (): string | undefined => {
  const { search } = useLocation();
  return new URLSearchParams(search).get('testInviteCode') ?? undefined;
};
